import {Component, EventEmitter, Input, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'si-confirm-action-dialog-icon',
  templateUrl: './confirm-action-dialog-icon.component.html',
  styleUrls: ['./confirm-action-dialog-icon.component.scss']
})
export class ConfirmActionDialogIconComponent {
  @Input() icon: string;
  @Input() tooltip: string;
  @Input() tooltipPosition = 'top';
  @Input() path: string;
  @Input() model: object = {};
  @Input() iconDialog = 'icon-notification font-color-main1';
  @Input() headerTitleDialog: string;
  @Input() titleDialog: string;
  @Input() subtitleDialog: string;
  @Output() updateChange = new EventEmitter<any>();
  displayDialog = false;

  constructor(private http: HttpClient) {
  }

  onClickIcon(event: Event): void {
    event.stopPropagation();
    if (this.titleDialog) {
      this.displayDialog = true;
    } else {
      this.onConfirmActionDialog();
    }
  }

  async onConfirmActionDialog(): Promise<any> {
    await this.put();
  }

  async put(): Promise<any> {
    if (!this.path) {
      return;
    }

    await this.http.put(this.path, this.model).toPromise();
  }
}
